import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-iqac-menu',
  templateUrl: './iqac-menu.component.html',
  styleUrls: ['./iqac-menu.component.scss']
})
export class IqacMenuComponent implements OnInit {

  currentRoute: any;
  constructor(
    public router: Router
  ) { }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      this.currentRoute = event.url;     
      console.log(this.currentRoute);     
    });
  }

}
